import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M9 19h6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 15v-3H5l7-7 7 7h-4v3H9z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowBigUpDash";
const ArrowBigUpDash = memo(themed(Icon));
export {
  ArrowBigUpDash
};
//# sourceMappingURL=arrow-big-up-dash.js.map
